export default "__VITE_ASSET__Dq4BTUL6__"